export default () => {
  self.onmessage = e => {
    self.postMessage({ status: 'success', message: 'metrics worker completed' });
  };

  self.onerror = e => {
    self.postMessage({ status: 'error', message: e });
  };
};
